import _ from 'lodash';
import { UnAnalyzedAst } from 'common/types/soql';
import { Option } from 'ts-option';

export function hasAnyFilter(maybeAst: Option<UnAnalyzedAst>): boolean {
  return maybeAst.map(ast => ast.having != null || ast.where != null)
    .getOrElseValue(false);
}
